import { Button, Tooltip } from "@mui/material";
import { IncidentTableData } from "../types";
import { geojsonFileMessage } from "./TooltipMessages";

const downloadFileToComputer = (filename: string, data: unknown): void => {
  const serialised = JSON.stringify(data, null, 2);
  const blob = new Blob([serialised], { type: "application/geo+json" });
  const url = URL.createObjectURL(blob);

  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  URL.revokeObjectURL(url);
};

const buildGeoJsonFilename = (
  solutionId: string,
  row: IncidentTableData,
): string => {
  return `incidents_${solutionId}_${row.scannedAt}_buffer-${row.boundaryBufferKm}.geojson`;
};

function DownloadFileButton({
  solutionId,
  row,
}: {
  solutionId: string;
  row: IncidentTableData;
}) {
  return (
    <Tooltip title={<h1 style={{ fontSize: "15px" }}>{geojsonFileMessage}</h1>}>
      <Button
        aria-label="download incident shapes"
        size="small"
        variant="text"
        sx={{ opacity: "60%", height: 20 }}
        onClick={() =>
          downloadFileToComputer(
            buildGeoJsonFilename(solutionId, row),
            row.incidentFileShapes,
          )
        }
      >
        ShapeLayer
      </Button>
    </Tooltip>
  );
}

export default DownloadFileButton;
